import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const WrapperStyled = styled(Box)(({ theme }) => ({
  backgroundColor: '#f9f9f9',
  padding: '16px',
  borderRadius: '4px',
  marginTop: '8px',
  width: '100%',
  border: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
